import request from '@/utils/request'
const apiPath = '/activity/advertisingPosition'
const sysBannerApi = {
  /**
   * 新增【广告位】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【广告位】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【广告位】
   */
  fetchList(query) {
    return request.get('/activity/advertisingPosition/tee/list', { params: query })
  },
  /**
   * 查看【广告位】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【广告位】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【快递配置】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setStatus(data){
    return request.put('/activity/advertisingPosition/tee/setStatus', data)
  },
  setOrderNo(data){
    return request.put(apiPath+'/tee/setOrderNo', data)
  },
  // setIsEnableExpress(data) {
  //   return request.put(apiPath + '/tee/setIsEnable', data)
  // },
  delCache(id){
    return request.get(`${apiPath}/delCache/${id}`)
  }
}
export default sysBannerApi
